<template>
  <div class="page-wrap">
    <div class="panel-card">

      <!-- Header -->
      <div class="panel-header">
        <div class="header-left">
          <button class="btn-back" @click="$router.push({ name: 'admin.notification' })">
            <i class="fa fa-arrow-left"></i>
          </button>
          <div class="header-text">
            <div class="header-title">
              <i class="fa fa-chart-bar"></i> Viewer Report
            </div>
            <div class="header-sub" v-if="notificationTitle">{{ notificationTitle }}</div>
          </div>
        </div>
      </div>

      <!-- Stats row -->
      <div class="stats-row" v-if="!dataLoading">
        <div class="stat-card total">
          <div class="stat-icon"><i class="fa fa-users"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ notifications.length }}</div>
            <div class="stat-label">Total Delivered</div>
          </div>
        </div>
        <div class="stat-card read-card">
          <div class="stat-icon"><i class="fa fa-check-circle"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ readCount }}</div>
            <div class="stat-label">Read</div>
          </div>
        </div>
        <div class="stat-card unread-card">
          <div class="stat-icon"><i class="fa fa-eye-slash"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ unreadCount }}</div>
            <div class="stat-label">Unread</div>
          </div>
        </div>
        <div class="stat-card rate-card" v-if="notifications.length > 0">
          <div class="stat-icon"><i class="fa fa-percentage"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ Math.round(readCount / notifications.length * 100) }}%</div>
            <div class="stat-label">Read Rate</div>
          </div>
        </div>
      </div>

      <!-- Loading -->
      <div class="state-box" v-if="dataLoading">
        <i class="fa fa-spinner fa-spin"></i>
        Loading report…
      </div>

      <!-- Empty -->
      <div class="state-box" v-else-if="notifications.length === 0">
        <i class="fa fa-inbox"></i>
        No viewer data available
      </div>

      <!-- Table -->
      <div v-else-if="!dataLoading && notifications.length > 0" style="overflow-x: auto;">
        <table class="report-table">
          <thead>
            <tr>
              <th style="width:40px;">#</th>
              <th>Client Name</th>
              <th>Client Type</th>
              <th style="text-align:center;">Read Status</th>
              <th>Read At</th>
              <th>Read By</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in notifications" :key="index">
              <td style="color:#a0aab8; font-size:12px;">{{ index + 1 }}</td>
              <td class="col-name">{{ item.client_name }}</td>
              <td>
                <span class="type-badge">{{ capitalize(item.client_type) }}</span>
              </td>
              <td style="text-align:center;">
                <span :class="['status-badge', item.is_read ? 'is-read' : 'is-unread']">
                  <i :class="item.is_read ? 'fa fa-check-circle' : 'fa fa-clock'"></i>
                  {{ item.is_read ? 'Read' : 'Not Read' }}
                </span>
              </td>
              <td class="col-date">{{ item.read_at ? formatDate(item.read_at) : '—' }}</td>
              <td class="col-name">{{ item.read_by || '—' }}</td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</template>

<script>
import { GET_NOTIFICATION_REPORT } from "@/core/services/store/actions.type";
import { SET_BREADCRUMB } from "@/core/services/store/mutations.type";
import { mapGetters } from "vuex";
export default {
  components: {},
  computed: {
    ...mapGetters(["currentUser"]),
    readCount() {
      return this.notifications.filter(n => n.is_read).length;
    },
    unreadCount() {
      return this.notifications.filter(n => !n.is_read).length;
    },
  },
  data() {
    return {
      notifications: [],
      notificationTitle: "",
      dataLoading: false,
    };
  },
  created() {
    const id = this.$route.params.notification_id;
    if (id) this.fetchNotificationReport(id);
  },
  mounted() {
    this.$store.commit(SET_BREADCRUMB, [
      { id: 1, title: "Dashboard", route: "client.dashboard" },
      { id: 2, title: "Notification", route: "admin.notification" },
      { id: 3, title: "Viewer Report", route: "" },
    ]);
  },
  methods: {
    fetchNotificationReport(notification_id) {
      this.dataLoading = true;
      this.$store.dispatch(GET_NOTIFICATION_REPORT, { notification_id })
        .then(response => {
          this.dataLoading = false;
          this.notifications = response.data || [];
          if (this.notifications.length > 0) {
            this.notificationTitle = this.notifications[0].notification_title;
          }
        })
        .catch(() => { this.dataLoading = false; });
    },
    formatDate(date) {
      if (!date) return "—";
      return new Date(date).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
    },
    capitalize(text) {
      if (!text) return "";
      return text.charAt(0).toUpperCase() + text.slice(1);
    },
  },
};
</script>

<style lang="scss" scoped>
.page-wrap {
  padding: 8px 0 80px;
  font-family: 'Segoe UI', sans-serif;
}

.panel-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(13, 27, 62, 0.07);
  overflow: hidden;
}

/* Header */
.panel-header {
  display: flex;
  align-items: center;
  padding: 14px 20px;
  background: #eef2fb;
  border-bottom: 1px solid #dde4f5;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.btn-back {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: 1.5px solid #c5d4f0;
  background: #fff;
  color: #389ad4;
  font-size: 13px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.15s;

  &:hover { background: #dde9f7; border-color: #389ad4; }
}

.header-text { min-width: 0; }

.header-title {
  font-size: 13px;
  font-weight: 700;
  color: #389ad4;
  display: flex;
  align-items: center;
  gap: 7px;
}

.header-sub {
  font-size: 12px;
  color: #7a8499;
  margin-top: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 480px;
}

/* Stats */
.stats-row {
  display: flex;
  gap: 1px;
  background: #f0f3fa;
  border-bottom: 1px solid #e8edf5;
}

.stat-card {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 18px;
  background: #fff;

  .stat-icon {
    width: 38px;
    height: 38px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    flex-shrink: 0;
  }

  .stat-value {
    font-size: 20px;
    font-weight: 700;
    line-height: 1;
    margin-bottom: 3px;
  }

  .stat-label {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.4px;
  }

  &.total {
    .stat-icon { background: #eef7fb; color: #389ad4; }
    .stat-value { color: #0d1b3e; }
    .stat-label { color: #7a8499; }
  }

  &.read-card {
    .stat-icon { background: #f0fdf4; color: #276749; }
    .stat-value { color: #276749; }
    .stat-label { color: #276749; opacity: 0.75; }
  }

  &.unread-card {
    .stat-icon { background: #fff5f5; color: #c53030; }
    .stat-value { color: #c53030; }
    .stat-label { color: #c53030; opacity: 0.75; }
  }

  &.rate-card {
    .stat-icon { background: #fdf4ff; color: #6b46c1; }
    .stat-value { color: #6b46c1; }
    .stat-label { color: #6b46c1; opacity: 0.75; }
  }
}

/* Table */
.report-table {
  width: 100%;
  font-size: 13px;
  border-collapse: collapse;

  thead tr th {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    color: #7a8499;
    padding: 10px 16px;
    border-bottom: 2px solid #eef0f8;
    background: #fff;
    white-space: nowrap;
  }

  tbody tr {
    border-bottom: 1px solid #f5f7fa;
    transition: background 0.15s;

    &:last-child { border-bottom: none; }
    &:hover { background: #f8fbff; }

    td {
      padding: 11px 16px;
      color: #2d3748;
      vertical-align: middle;
    }
  }
}

.col-name {
  font-weight: 500;
  color: #0d1b3e;
}

.col-date {
  font-size: 12px;
  color: #4a5568;
  white-space: nowrap;
}

.type-badge {
  display: inline-block;
  padding: 2px 9px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  background: #eef2fb;
  color: #185FA5;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 11.5px;
  font-weight: 600;
  white-space: nowrap;

  &.is-read   { background: #c6f6d5; color: #276749; }
  &.is-unread { background: #fed7d7; color: #c53030; }
}

/* Loading / Empty */
.state-box {
  text-align: center;
  padding: 56px 24px;
  color: #a0aab8;
  font-size: 13px;

  i {
    font-size: 30px;
    display: block;
    margin-bottom: 10px;
    opacity: 0.45;
  }
}
</style>
